import { captureException } from '@reapit-sales/sentry-provider'
import { createContext, useContext, useState } from 'react'
import { HANDLED_HTTP_STATUS_CODES } from './constant'

export interface NetworkErrorInfo {
  isError?: boolean
  errorCode?: string
  errorStatus?: number
  errorMessage?: string
  originalErrorMessage?: string
  errorTitle?: string
  isRedirect?: boolean
}

interface ErrorPagesContextType {
  errorInfo: NetworkErrorInfo
  setError: (errConfig: NetworkErrorInfo) => void
}

export const ErrorPagesContext = createContext<ErrorPagesContextType>({
  setError: () => {},
  errorInfo: {},
})

export const useErrorPagesContext = () => {
  const context = useContext(ErrorPagesContext)
  if (!context) {
    throw new Error('useErrorPagesContext must be used within an ErrorPagesProvider')
  }
  return context
}

export const ErrorPagesProvider = ({ children }: { children: React.ReactNode }) => {
  const [errorInfo, setErrorInfo] = useState<NetworkErrorInfo>({})

  const onSetError = (err: NetworkErrorInfo) => {
    const isError = HANDLED_HTTP_STATUS_CODES.includes(err?.errorStatus as number)
    if (isError) {
      const newError = new Error(err.errorMessage)
      captureException(newError, {
        extra: {
          errorInfo: err,
        },
      })
    }
    setErrorInfo({ ...err, isError })
  }

  return (
    <ErrorPagesContext.Provider
      value={{
        setError: onSetError,
        errorInfo,
      }}
    >
      {children}
    </ErrorPagesContext.Provider>
  )
}
